<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="product-detail container page-content">
                <div class="row">
                    <div v-if="isMobile" class="col-12 col-lg-7 product-detail__carousel">
                        <item-image-carousel :showThumbs="false" :plugin-path="ceresPluginPath" image-url-accessor="url"></item-image-carousel>
                    </div>
                    <div v-else class="col-12 col-lg-7 product-detail__carousel">
                        <single-images :current-variation="currentVariation"></single-images>
                    </div>
                    <div class="col-12 col-lg-5 product-detail__content">
                        <div>
<!--                            &lt;!&ndash; START SINGLEITEM_DETAILS SCROLL => v-stick-in-parent&ndash;&gt;-->
<!--                            <div class="product-detail__producer" v-if="currentVariation.filter.hasManufacturer">-->
<!--                                {{ currentVariation.item.manufacturer.externalName }}-->
<!--                            </div>-->

                            <h1 class="product-detail__title" data-testing="item-name">
                                {{ currentVariation | itemName }}
                            </h1>

                            <h2 class="product-detail__sub-title">

                                {{ getColor }}
                            </h2>

                            <slot name="crossselling"></slot>

<!--                            <slot name="crosssellingsimilar"></slot>-->

<!--                            <slot name="before-price"></slot>-->

<!--                            <div class="product-detail__property-list" v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">-->
<!--                                <order-property-list></order-property-list>-->
<!--                            </div>-->

                            <!--<graduated-prices></graduated-prices>-->

<!--                            <item-price :show-cross-price="isRecommendedPriceActive"></item-price>-->

                            <slot name="after-price"></slot>


<!--                            <slot name="additional-content-after-vat"></slot>-->


<!--                            <item-availability class="product-detail__availability"></item-availability>-->


                            <!-- Variation -->
                            <div class="product-detail__variation" v-if="attributes.length || Object.keys(units).length">
                                <variation-select v-if="currentVariation.filter.isSalable || (!currentVariation.filter.isSalable && currentVariation.filter.hasActiveChildren) || hasSalableVariation"></variation-select>
                            </div>
                            <!-- /Variation -->

<!--                            <p class="product-detail__short-description"-->
<!--                               v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"-->
<!--                               v-html="currentVariation.texts.shortDescription">-->
<!--                            </p>-->

                            <!-- Item Bundle -->
                            <div class="product-detail__bundle">
                                <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'" :bundle-type="currentVariation.variation.bundleType" :bundle-components="currentVariation.bundleComponents"></item-bundle>
                            </div>
                            <!-- /Item Bundle -->

                            <slot name="before-add-to-basket"></slot>

                            <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                {{ $translate("Ceres::Template.singleItemSetInfo") }}
                            </div>

                            <div v-else class="product-detail__add-to-basket row">
                                <add-to-basket
                                        class="col-12"
                                        :variations-obj="variationsObj"
                                        :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
										:has-order-properties="currentVariation.hasOrderProperties"
										:has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                        :use-large-scale="false"
                                        :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice"
                                    >
                                </add-to-basket>
<!--                                <div v-if="isWishListEnabled" class="product-detail-wishlist col-2">-->
<!--                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>-->
<!--                                </div>-->

                                <div class="col-12 product-detail__vat-information">{{ $translate("FLGNTLT::Template.vatInformation") }}</div>
                            </div>

                            <slot name="after-add-to-basket"></slot>
                            <slot name="additional-content-after-add-to-basket"></slot>

<!--                            <div class="row mt-2">-->
<!--                                <div class="col">-->
<!--                                    <span class="product-detail__id">-->
<!--                                        {{ $translate("Ceres::Template.singleItemNumber") }}:-->
<!--                                        {{ currentVariation.variation.number }}-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                                <div class="col">-->
<!--                                    <span class="product-detail-price&#45;&#45;vat">-->
<!--                                        {{ $translate("Ceres::Template.singleItemFootnote1") }} <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}-->
<!--                                        <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts" :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>-->
<!--                                        <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="single-details__wrapper single-details__wrapper--1" v-if="currentVariation.texts.description !== ''">
                                <div class="single-details__headline">
                                    {{ $translate('FLGNTLT::Template.details') }}
                                </div>
                                <div class="single-details__text" v-html="currentVariation.texts.description"></div><!-- war currentVariation.texts.description -->
                            </div>

                            <div class="single-details__wrapper single-details__wrapper--2" v-if="currentVariation.texts.technicalData !== ''">
                                <div class="single-details__headline">
                                    {{ $translate('FLGNTLT::Template.sizeinfo') }}
                                </div>
                                <div class="single-details__text" v-html="currentVariation.texts.technicalData"></div><!-- war currentVariation.texts.technicalData -->
                            </div>

<!--                            <div class="single-details__wrapper single-details__wrapper&#45;&#45;3" v-if="currentVariation.texts.technicalData !== ''">-->
<!--                                <div class="single-details__headline">-->
<!--                                    {{ $translate('FLGNTLT::Template.careInstructions') }}-->
<!--                                </div>-->
<!--                                <div class="single-details__text" v-html="currentVariation.texts.technicalData"></div>-->
<!--                            </div>-->

                            <div class="size-chart__wrapper" v-if="sizechartImg !== ''">
                                <div class="size-chart__headline" data-toggle="modal" href="#sizechart">
                                    {{ $translate('FLGNTLT::Template.sizechart') }}
                                </div>
<!--                                <div class="size-chart__headline" data-toggle="modal" href="#newsletter-modal">Sizechart</div>-->
                                <size-chart></size-chart>
                            </div>
                        </div>
                    </div>
                </div>

                <slot name="dropzone1"></slot>

                <slot name="item-list-container"></slot>
                <slot name="feedback-container"></slot>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import SingleImages from "./SingleImages.vue"

export default {

    name: "single-item",

    components:
    {
        "single-images": SingleImages
    },

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        variationsObj: {
            type: Array,
            default: () => []
        },
        afterKey: Object
    },

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    data(){
        return{
            isMobile: true
        }
    },

    computed:
    {
        hasSalableVariation(){
            let returnVal = false;

            for(let key in this.variationsObj){
                if(this.variationsObj[key].isSalable){
                    returnVal = true;
                    break;
                }
            }

            return returnVal;
        },

        ceresPluginPath(){
            return App.pluginPath
        },

        sizechartImg() {
            let returnVal = "";

            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[key].properties) {
                    if (this.currentVariation.variationProperties[key].properties[key2].id === 2) {
                        returnVal = this.currentVariation.variationProperties[key].properties[key2].values.value
                    }
                }
            }

            return returnVal
        },

        getColor() {
            let returnVal;

            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[key].properties) {
                    if (this.currentVariation.variationProperties[key].properties[key2].id === 1) {
                        returnVal = this.currentVariation.variationProperties[key].properties[key2].values.value
                    }
                }
            }

            return returnVal
        },

        itemConfig()
        {
            return App.config.item.itemData;
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted()
    {
        this.isMobile = window.innerWidth <= 1200;
        this.$nextTick(() =>
        {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId:             this.itemId,
                attributes:         this.attributesData,
                variations:         this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey:           this.afterKey
            });

            if (this.isItemSet)
            {
                this.$store.dispatch("initSetComponents", this.itemData);
            }
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
    {
        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
